import SettingContact from '../ListSidebar/settingContact';
import { Stack, Typography, DialogContentText, DialogTitle, Divider } from '@material-ui/core';
import { DialogAnimate } from '../../../../components/animate';
import Scrollbar from '../../../../components/Scrollbar';
// ----------------------------------------------------------------------
import TextFieldsIcon from '@mui/icons-material/TextFields';
export default function DialogSetting({ isOpenSettingContact, setIsOpenSettingContact }) {
    return (
        <DialogAnimate sx={{ maxHeight: 900 }} open={isOpenSettingContact} onClose={() => setIsOpenSettingContact(false)} fullWidth maxWidth="xl">
            <DialogTitle>
                <Stack direction="row" justifyContent="flex-start" spacing={2} >
                    <TextFieldsIcon style={{ fontSize: '36px', marginTop: '10px', color: '#2978d5' }} ></TextFieldsIcon>
                    <Typography variant='h4' style={{ marginTop: '10px' }}>Thuộc tính danh bạ</Typography>
                </Stack>
            </DialogTitle>
            <Divider></Divider>
            <DialogContentText>
                <Scrollbar>
                    <SettingContact></SettingContact>
                </Scrollbar>
            </DialogContentText>
        </DialogAnimate>
    );
}
